import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import MealCalculator from './components/MealCalculator';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancelled from './components/PaymentCancelled';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<MealCalculator />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancelled" element={<PaymentCancelled />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;